import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const CookieBanner = () => {
  const [show, setShow] = useState(false);
  const { t } = useLang();

  useEffect(() => {
    if (!localStorage.getItem("cookie_consent")) setShow(true);
  }, []);

  const accept = () => { localStorage.setItem("cookie_consent", "accepted"); setShow(false); };
  const decline = () => { localStorage.setItem("cookie_consent", "declined"); setShow(false); };

  if (!show) return null;
  return (
    <div data-testid="cookie-banner" className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 sm:max-w-md z-[60] bg-white border border-slate-200 rounded-3xl p-6 shadow-2xl shadow-slate-400/20">
      <div className="flex items-center gap-2 mb-2">
        <Cookie className="w-5 h-5 text-blue-600" />
        <h4 className="text-slate-900 font-semibold">{t("cookie.title")}</h4>
      </div>
      <p className="text-sm text-slate-500 mb-4">
        {t("cookie.text")}{" "}
        <Link to="/datenschutz" className="text-blue-600 hover:underline">{t("cookie.privacyLink")}</Link>.
      </p>
      <div className="flex gap-3">
        <button data-testid="cookie-accept" onClick={accept} className="btn-blue !py-2.5 flex-1 text-sm">{t("cookie.accept")}</button>
        <button data-testid="cookie-decline" onClick={decline} className="btn-ghost !py-2.5 flex-1 text-sm">{t("cookie.decline")}</button>
      </div>
    </div>
  );
};
